import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { UserColumnStructure } from "../../../Data/UserManagement";
import { useUser } from "../../../hooks/useUser";
import {
  UserModalDetailsType,
  UserRowType,
} from "../../../Types/UserManagement";
import { SearchTableButton } from "../../../utils/Constant";
import CommonModal from "../../atoms/Common/CommonModal";
import { YesNo } from "../../molecules/Forms/YesNo";

const UserManagementContainer = () => {
  const { error, users, deleteUser } = useUser();
  const [filterText, setFilterText] = useState("");
  const [tableData, setTableData] = useState<UserRowType[]>([]);

  const [modalDetails, setModalDetails] = useState<
    UserModalDetailsType | undefined
  >();

  const centeredToggle = () => {
    setModalDetails(undefined);
  };

  useEffect(() => {
    if (users) {
      setTableData(users);
    }
  }, [users]);

  const filteredItems = tableData.filter((item) => {
    item.modalDetails = setModalDetails;
    return (
      (item.id && item.id.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.firstName &&
        item.firstName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastName &&
        item.lastName.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  const subHeaderComponentMemo = useMemo(
    () => (
      <Row className="w-100 d-flex justify-content-between">
        <Col
          id="API-1_filter"
          className="w-50 dataTables_filter d-flex align-items-center justify-content-center "
        >
          <Label className="me-1">{SearchTableButton}:</Label>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            type="search"
            value={filterText}
            placeholder="Search by name or keywords"
          />
        </Col>
        <Col className="w-50 d-flex justify-content-end">
          {/* <Btn
            color="primary"
            className="mb-3"
            onClick={() =>
              setModalDetails({ id: undefined, type: FormAccess.CREATE })
            }
          >
            {"Add Company"}
          </Btn> */}
        </Col>
      </Row>
    ),
    [filterText]
  );

  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <div className="table-responsive">
            <div id="API-1" className="dataTables_wrapper">
              <DataTable
                data={filteredItems}
                columns={UserColumnStructure}
                striped={true}
                pagination
                className="display"
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            </div>
          </div>
          <CommonModal
            centered
            isOpen={modalDetails !== undefined}
            toggle={centeredToggle}
          >
            <div className="modal-toggle-wrapper">
              <YesNo
                centeredToggle={centeredToggle}
                onYesClick={() => {
                  if (modalDetails != null) {
                    deleteUser(modalDetails!.id!);
                    centeredToggle();
                  }
                }}
              />
            </div>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserManagementContainer;
